
import {throwError as observableThrowError,  Observable } from 'rxjs';
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";

@Injectable({
	providedIn: 'root'
})
export class HcmConfigService {

	constructor(private http: HttpClient) {}

	public getTenantConfig(): Observable<any> {
		try {
			return this.http.get(`HCM/tenantsetting`);
		} catch (e) {
			return observableThrowError(e);
		}
	}

	public getHcmFeaturePermissions(): Observable<any> {
		try {
			return this.http.get(`HCM/featurecontrol`);
		} catch (e) {
			return observableThrowError(e);
		}
	}

	public getHcmSessionInfo(): Observable<any> {
		try {
			return this.http.get(`HCM/login`).pipe(map((loginData: any) => loginData.session));
		} catch (e) {
			return Observable.throw(e);
		}
	}
}
